jQuery(function ($) {
  const name = "genbakaikaku";
  const domain = "fukushizaidan.jp";

  const email = name + "@" + domain;

  $(".js-mail")
    .text(email)
    .attr("href", "mailto:" + email);

});